import { Image, Platform} from 'react-native';
import { Theme, ThemedText, ThemedView, themeTextVariants } from '@app/theme';
import Button from '@app/sharedComponents/Button/Button';
import LinearGradient from 'react-native-linear-gradient';
import ROUTE from '@app/navigationApp/routes';
import { useAppDispatch, useAppSelector } from '@app/store/hooks';
import { endpoints } from '@app/api/apis';
import axios from 'axios';
import { useEffect, useMemo, useState } from 'react';
import { formatIndianCurrency, isEmptyObject } from '@app/utils/utility';
import { updateShortfallData } from '@app/store/slices/authSlice';
import { isCurrentTimeAfterSixPM, isMobileView } from '@app/utils';
import { LENDER_ID } from '@app/constants/platformPartners';
import CalendarIcon from '../../../assets/svg/CalendarIcon';
import { useTheme } from '@shopify/restyle';
const CALENDAR_IMAGE = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Calendar.png';

const ShortFallCard = ({navigation}) => {
  const userDetails = useAppSelector((state) => state.auth.userDetails);
  const shortFallDetails = useAppSelector((state) => state.auth.shortFallDetails);
  const {colors} = useTheme<Theme>();
  const dispatch = useAppDispatch();
  const fetchShortFallData = () => {
    const url = endpoints.shortFallDetails + userDetails?.linkedCredits[0]?.creditId
    axios.get(url)
    .then((res)=>{
        dispatch(updateShortfallData(res?.data || {}))
    }
    ).catch((err)=>{
      dispatch(updateShortfallData({}))
      console.log('fetchShortFallData',err)
    }
    )
  }

  useEffect(()=>{
    fetchShortFallData()
  },[])

  const viewShortfallDetail = ()=>{
    navigation.navigate(ROUTE.SHORTFALL_DETAILS,{shortFallDetails})
  }
  if(isEmptyObject(shortFallDetails) || shortFallDetails===""){
    return null
  }

    let shortfallDesc = '';
    const isAfterSixPM = isCurrentTimeAfterSixPM();
    if(shortFallDetails?.daysLeft > 1){
        if(shortFallDetails?.lenderId?.toLowerCase() === LENDER_ID.TATA.toLowerCase())
            shortfallDesc = `${shortFallDetails?.daysLeft} days left to meet shortfall`
        else shortfallDesc = `${shortFallDetails?.daysLeft} Working days left to meet shortfall`
    }
    else if(shortFallDetails?.daysLeft === 1){
        if(isAfterSixPM){
            shortfallDesc = 'Shortfall deadline has expired!'
        } else {
            shortfallDesc = 'Last reminder: Meet shortfall before 6 PM'
        }
    }
    else shortfallDesc = `Portfolio sell-off initiated.`


    return(
        <>
            <ThemedView mx='lg' mt='2xl' borderColor='border-primary' backgroundColor='bg-surface-emphasis-secondary' borderWidth={1} borderTopLeftRadius='lg' borderTopRightRadius='lg'  >
              <LinearGradient
                colors={[colors['bg-surface-primary'],colors['bg-fill-error']]}
                start={{x: 0, y: 1}}
                end={{x: 1, y: 1}}
                style={{flex: 1,paddingHorizontal:16,paddingTop:8,paddingBottom:20,borderTopLeftRadius:16,borderTopRightRadius:16,flexDirection:'row', flexWrap:'wrap',zIndex:100}}
              >
                <ThemedText variant='b4b' color='text-error'>
                SHORTFALL ALERT! {''}
                <ThemedText variant='b4r' color='text-error'>
                Your credit limit has dropped below outstanding amount
                </ThemedText>
                </ThemedText>
                <ThemedView style={{position:'absolute',top:0,right:16,zIndex:0}}>
                <Image source={{uri:'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Group.png'}} style={{width:isMobileView() ? 72 : 52,height:isMobileView() ? 48 : 32}}/>
                </ThemedView>
              </LinearGradient>
            </ThemedView>
            <ThemedView mx='lg' p="lg" borderColor='border-primary' backgroundColor='bg-fill-primary' borderWidth={1} borderRadius='lg' style={{marginTop:-14}} >
              <ThemedView flexDirection='row' justifyContent='space-between' alignItems='center'>
                <ThemedView flex={1}>
                  <ThemedText color='text-secondary'  variant='b4r' pb='2xs' >
                    Shortfall amount
                  </ThemedText>
                  <ThemedView flexDirection='row' alignItems='center'>
                    <ThemedText color='text-error'  variant='l1'>
                      ₹
                    </ThemedText>
                    <ThemedText color='text-error'  variant='h1b'>
                      {formatIndianCurrency(shortFallDetails?.shortfallAmount)}
                    </ThemedText>
                  </ThemedView>
                  
                </ThemedView>
                <ThemedView flex={1}>
                  <Button type='SOLID' label='View details' size='SM' handlePress={viewShortfallDetail}/>
                </ThemedView>
              </ThemedView>
              <ThemedView borderTopColor='border-primary' mt='md' pt='md'borderTopWidth={1} flexDirection='row' >
              {/* <Image source={{uri:CALENDAR_IMAGE}} style={{width:36,height:36}}/> */}
              <CalendarIcon 
                bgColor={colors['bg-fill-secondary']} 
                color1={colors['border-emphasis-primary']}
                color2={colors['bg-fill-emphasis-primary-1']}
                color3={colors['icon-action-primary']}
                color4={colors['icon-error']}
                color5={colors['icon-error']}
              />
              <ThemedView ml='sm'>
                <ThemedView flexDirection='row' alignItems='center' >
                <ThemedText color='text-primary'  variant='b4b' >
                {shortfallDesc}
                </ThemedText>
                {shortFallDetails?.daysLeft<=0 && <Button type='TEXT' label='Learn more' size='SM' handlePress={()=>{navigation.navigate(ROUTE.WHAT_IS_SHORTFALL)}} />}
                </ThemedView>
                <ThemedText color='text-secondary'  variant='b5s'>
                Failure to meet shortfall will lead to portfolio sell-off
                </ThemedText>
              </ThemedView>
              </ThemedView>
            </ThemedView>
        </>
    )
}

export default ShortFallCard;